import gql from 'graphql-tag';

import { MovingLinesFragment, fragmentBettingOpportunities, getSelections } from './fragments';

export const GET_BUILT_BET = gql`
  query getBuiltBet($code: String!) {
    builtBet(where: { code: $code }) {
      events {
        ...event
      }
      opportunities {
        ...opportunities
      }
      requestedSelectionCount
      retrievedSelectionCount
    }
  }

  fragment event on Event {
    id
    name
    ancestors
    status
    displayed
    isInPlay
    startDateTime
    marketField: markets {
      ...market
    }
  }

  fragment market on Market {
    id
    name
    hcapValue
    status
    displayed
    ${getSelections()}
    ...MovingLines
  }

  ${fragmentBettingOpportunities}
  ${MovingLinesFragment}
`;

export const STORE_BUILT_BET = gql`
  mutation StoreBuiltBet(
    $channel: String!
    $legs: [LegInput!]!
    $combinationSelections: [CombinationSelection]!
    $walletType: String
    $selectedBetsOnly: Boolean
    $requestedLine: Float
  ) {
    storeBuiltBet(
      where: {
        channel: $channel
        legs: $legs
        combinationSelections: $combinationSelections
        walletType: $walletType
        selectedBetsOnly: $selectedBetsOnly
        requestedLine: $requestedLine
      }
    ) {
      code
    }
  }
`;
